import { Button, Flex, Heading, HStack, Text, Tooltip } from "@chakra-ui/react";
import { IconButtonGray } from "components/Atomos/Buttons/IconButtonGray";
import { useState } from "react";
import { FaDownload } from "react-icons/fa";
import { RiArrowLeftLine } from "react-icons/ri";
import { Document, Page } from "react-pdf";
import { useDispatch } from "react-redux";
import {
  clearValidacao,
  ValidarDocumentoResponse
} from "store/modules/servicos/actions/validarDocumento";

type InfoDocumentoProps = {
  documento: ValidarDocumentoResponse;
};

function PdfReactPdf({ src }: { src: string }) {
  const [numPages, setNumPages] = useState<number>(0);
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  return (
    <Flex w="full">
      <Document file={src} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from({ length: numPages }).map((_, idx) => (
          <Page
            key={`pdf-page-${idx + 1}`}
            pageIndex={idx}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    </Flex>
  );
}

const InfoDocumento = ({ documento }: InfoDocumentoProps) => {
  const formatDate = (date: string) => {
    return date?.split("-")?.reverse()?.join("/") ?? "-";
  };

  const formatHour = (hour: string) => {
    const [hours, minutes] = hour?.split(":") ?? [];
    return `${hours}h${minutes}`;
  };

  const dispatch = useDispatch();
  const removeInformation = () => {
    dispatch(clearValidacao());
  };

  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = documento.caminhoArquivo;
    link.setAttribute(
      "download",
      documento.caminhoArquivo.split("?")[0].split("/").pop() || "document.pdf"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Flex direction="column" maxW="1200px" mx="auto" px="8" gap={4}>
      <Button
        colorScheme="gray"
        color="gray.900"
        variant="link"
        gap={2}
        onClick={removeInformation}
        w="fit-content"
      >
        <RiArrowLeftLine /> Voltar
      </Button>
      <Heading fontSize="large">Dados de validação do documento</Heading>
      <Text>Impresso por: {documento.impressoPor}</Text>
      <Text>Data de emissão: {formatDate(documento.dataEmissao)}</Text>
      <Text>Hora de emissão: {formatHour(documento.horaEmissao)}</Text>
      <Text>Data de validade: {formatDate(documento.dataValidade)}</Text>

      {documento.caminhoArquivo && (
        <>
          <HStack w="100%" justifyContent="space-between" align="center">
            <Heading m={0} fontSize="large" mt={4}>
              Documento impresso
            </Heading>

            <Tooltip label="Baixar arquivo" placement="top">
              <IconButtonGray
                aria-label="Download"
                icon={<FaDownload />}
                onClick={downloadFile}
              />
            </Tooltip>
          </HStack>

          <PdfReactPdf src={documento.caminhoArquivo} />
        </>
      )}
    </Flex>
  );
};

export default InfoDocumento;
